export const smoothScrollTopAndRemember = (duration = 300) => {
  const savedPosition = window.pageYOffset;

  return new Promise((resolve) => {
    const startTime = performance.now();

    function scrollStep(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);

      const easing = 1 - Math.pow(1 - progress, 3);
      window.scrollTo(0, savedPosition * (1 - easing));

      if (progress < 1) {
        requestAnimationFrame(scrollStep);
      } else {
        resolve(savedPosition); // 저장된 위치를 반환
      }
    }

    requestAnimationFrame(scrollStep);
  });
};

export const smoothScrollToSaved = (savedPosition, duration = 300) => {
  return new Promise((resolve) => {
    const startPosition = window.pageYOffset;
    const startTime = performance.now();

    function scrollStep(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);

      const easing = 1 - Math.pow(1 - progress, 3);
      const currentPos = startPosition + (savedPosition - startPosition) * easing;
      window.scrollTo(0, currentPos);

      if (progress < 1) {
        requestAnimationFrame(scrollStep);
      } else {
        resolve();
      }
    }

    requestAnimationFrame(scrollStep);
  });
};
